// store/useActions.ts
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDispatch } from 'react-redux'
// eslint-disable-next-line import/no-extraneous-dependencies
import { bindActionCreators } from 'redux'
import { setIsAuth } from 'modules/app/store'
import { setPostFilter } from './feedSlice'; // Already imported ✓
import {
  setIsSoundOn,
  setIsBecomeOnline,
  setIsBecomeOffline,
  setIsGetAppModal,
  setTryAppModal,
  setIsActiveCaptions,
  setFeedStateId,
  setIsSlideChange,
  setIsShareOpened,
  setIsOpenBasket,
  setIsAppointmentBookingOpen,
  setIsCommentsVisible,
  setIsButtonMenuVisible
} from '../modules/feed/store/index'

const allActions = {
  setIsSoundOn,
  setIsBecomeOnline,
  setIsBecomeOffline,
  setIsGetAppModal,
  setTryAppModal,
  setIsActiveCaptions,
  setFeedStateId,
  setIsAuth,
  setIsSlideChange,
  setIsShareOpened,
  setIsOpenBasket,
  setIsAppointmentBookingOpen,
  setIsCommentsVisible,
  setIsButtonMenuVisible,
  setPostFilter,
}

export const useActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(allActions, dispatch)
}